<app-map class="full"></app-map>
<app-menu class="floating-menu"></app-menu>
<mat-card *ngIf="selectedVehiclePopupOpen">
  <app-vehicle-popup></app-vehicle-popup>
  <button mat-icon-button (click)="toogleSelectedVehiclePopup()">
    <mat-icon aria-hidden="false">close</mat-icon>
  </button>
</mat-card>
